module.exports = __webpack_public_path__ + "img/norte.5c5777f2.svg";